import JWT from "jwt-decode";
import { jwtToken } from "../types/genericTypes";
import urlConfig from "../../config/domain";
import jwt_decode from "jwt-decode";
interface sType {
	[sType: string]: any; //indexer
}
let storage: sType;
//stores all types of browser storage data onto these local variable
storage = {
	session: window.sessionStorage,
	local: window.localStorage,
	cookie: document.cookie,
	appInfo: JWT(urlConfig.appidkey)
};
//helps in fetching key based values which are stored in storage local
const bStrg = (key: string) => {
	return storage[key];
};
//help is creating new storage other than built in browser storage
export const setbStrg = (key: string, val: any) => {
	storage[key] = val;
};
//provides the parsed JWT token info on access
export const parsedToken = (): jwtToken | null => { 
    let parToken: jwtToken | null = bStrg("local").jwt_token ? JWT(bStrg("local").jwt_token) : null;
    const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if(params && params.auth_token) {
            localStorage.setItem("jwt_token",params.auth_token)
            const token: any = params.auth_token;
        var decoded_token : any = jwt_decode(token);
		localStorage.setItem("lgnSrc",decoded_token.lgnSrc);
        parToken = decoded_token; 
        }
    return parToken;
};
parsedToken();

export default bStrg;
